// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".locale-changer{cursor:pointer!important}.multiselect__input,.multiselect__single{line-height:unset!important;vertical-align:baseline!important}.option__image{margin-bottom:5px;margin-right:5px}.option__title{font-weight:700}", ""]);
// Exports
module.exports = exports;
